import ReportsTable from 'components/Tables/Reports/ReportsTable';
import React from 'react';

const ReportGeneration = ({children}) => {
  return (
    <div className='mt-4 '>
      <section>
        <div className='container'>
          <div className='row'>
            <ReportsTable />
          {/* {children} */}
            {/* Add your store management components here */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReportGeneration;